import { render, staticRenderFns } from "./Fast_internet_home_G11.vue?vue&type=template&id=57a71b5c&scoped=true&"
import script from "./Fast_internet_home_G11.vue?vue&type=script&lang=js&"
export * from "./Fast_internet_home_G11.vue?vue&type=script&lang=js&"
import style0 from "./Fast_internet_home_G11.vue?vue&type=style&index=0&id=57a71b5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a71b5c",
  null
  
)

export default component.exports